import React from "react";
import { Link } from "react-router-dom";

export default function PremiumBanner() {
  return (
    <section data-testid="premium-banner" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="relative rounded-[32px] overflow-hidden">
          <div className="absolute inset-0 hero-mesh grain-overlay" />
          <div className="absolute inset-0 opacity-90">
            <img
              src="https://res.cloudinary.com/dstg4juld/image/upload/v1787466847/banners/aewuh13yr2fh3pryxenb.png"
              alt="Romantic Couple"
              className="w-full h-full object-cover object-[center_30%]"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#FAF8F5]/90 via-[#FAF8F5]/50 to-transparent" />
          <div className="relative z-10 px-8 md:px-20 py-16 md:py-24 flex justify-start">
            <div className="text-left max-w-lg">
              <p className="overline">Every gift, a chapter</p>
              <h3 className="mt-4 font-display font-semibold text-[#1C1924] text-4xl md:text-5xl tracking-tight leading-[1.05]">
                Every gift tells a <span className="font-serif-italic text-[#E5497C] block mt-1">love story.</span>
              </h3>
              <p className="mt-5 text-[#4A4652] text-[15px] md:text-[16px] mr-auto leading-relaxed">
                Because distance shouldn’t change how loved they feel — begin their next chapter with something they’ll hold on to.
              </p>
              <Link to="/shop" data-testid="premium-banner-shop-btn" className="btn-primary mt-8 inline-flex">Shop Now →</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
